import { useBranding } from "../../../Shared/components/BrandingProvider/BrandingProvider";
import { useCompany } from "../../../Shared/components/CompanyProvider/CompanyProvider";
import { useOrderFlow } from "../../OrderFlowProvider/OrderFlowContext";
/**
 * Returns values to be used in the CartButton for showing a custom icon and pricing breakdown.
 * @returns customCartIconUrl, usesCustomCartIcon,
    isCustomCartIconWhite, usesSimplifiedPricingBreakdown
 */
export const useCartButton = () => {
    var _a, _b;
    const { store } = useOrderFlow();
    const { imgBaseUrl } = useCompany();
    const branding = useBranding();
    const customCartFileName = (_a = branding.branding.OrderFlowMyMealsCartIcon) === null || _a === void 0 ? void 0 : _a.FileUpload;
    const usesCustomCartIcon = Boolean(customCartFileName);
    const isCustomCartIconWhite = (_b = branding.branding.OrderFlowMyMealsCartIcon) === null || _b === void 0 ? void 0 : _b.IsWhite;
    const customCartIconUrl = `${imgBaseUrl}img/brand_logos/${customCartFileName}`;
    return {
        customCartIconUrl,
        usesCustomCartIcon,
        isCustomCartIconWhite,
        usesSimplifiedPricingBreakdown: store.model.CartSettings.DisplaySimplifiedPricingBreakdown,
    };
};
